import { Component, Inject, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { DataARLedgerModel } from '../../../../models/accountsReceivable/data-ar-ledger.model';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ARService } from '../../ar.service';
import { DataARLedgerListModel } from '../../models/data-ar-ledger-list.model';
import { CfgARAccountModel } from '../../../../models/accountsReceivable/cfg-ar-account.model';
import { LOCIDModel } from '../../models/select-tdocid-locid.model';
import { EnumValidValueItemModel } from '../../../../models/enum/enum-valid-value-item.model';
import { ArLedgerItemSelectComponent } from '../ar-ledger-item-select/ar-ledger-item-select.component';
import { DataArLedgerCredits } from '../../models/data-ar-ledger-credits';
import { Globals } from '../../../../globals';
import { TdoTableSelectionEvent } from '../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import { ConversionUtilities } from '../../../../utilities/conversion.utilities';
import { CurrencyPipe } from '@angular/common';
import { DataARPaymentModel } from '../../../../models/accountsReceivable/data-ar-payment.model';
import { TdoNoteAssociatedObject, TdoNoteSaveModel } from '../../../../main-interface/controls/tdo-notes/models/tdo-note-save-model';
import { MessagingConstants } from '../../../../models/MessagingConstants';
import { MessagingService } from '../../../../services/messaging.service';
import { NotesService } from '../../../../services/notes.service';
import { NoteCategoryEnum } from '../../../../models/enum/note-category.enum';
import { NoteTypeEnum } from '../../../../models/enum/note-type.enum';
import { TemplatePortal } from '@angular/cdk/portal';
import { fromEvent, Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ArDebitCreditReasonsComponent } from '../ar-debit-credit-reasons/ar-debit-credit-reasons.component';
import { DataARCreditDebitReasonModel } from '../../../../models/accountsReceivable/data-ar-credit-debit-reason.model';
import { MatRadioChange } from '@angular/material/radio';
import { CreditCardRefundRequest } from '../../../../models/accountsReceivable/credit-card-refund-request.model';
import { ToastrService } from 'ngx-toastr';
import { CreditCardRefundablePaymentModel } from '../../../../models/accountsReceivable/credit-card-refundable-payment.model';
import { MatTable } from '@angular/material/table';
import { ArIntegration_QuickBooks, Constants } from 'src/app/constants';
import { StaticDataService } from 'src/app/services/static-data.service';
import { LEDGER_ITEM_STATUS } from 'src/app/models/constants/ledger-item-status.model';

@Component({
  selector: 'app-create-adjustment2',
  templateUrl: './create-adjustment2.component.html',
  styleUrls: ['./create-adjustment2.component.scss'],
})
export class CreateAdjustment2Component implements OnInit {

  @ViewChild('editReasonContext') editReasonContextTemplate: TemplateRef<any>;
  @ViewChild('ccRefundTable') ccRefundTable: MatTable<any>;

  LOCID: number;
  isLoading: boolean = false;
  type: string = ''; // credit/debit
  title: string = '';
  ledgerItem: DataARLedgerListModel; // DataARLedgerModel;
  ledgerItemText: string = '';
  ledgerItems: DataARLedgerListModel[];
  ledgerItemsList: DataARLedgerListModel[];
  ledgerItemsCredits: DataARLedgerListModel[];
  enumARLedgerItemOriginTypePatient: string = '00000207-1000-0000-0000-000000000002';
  enumARLedgerItemOriginTypeInsurance: string = '00000207-1000-0000-0000-000000000001';
  enumARLedgerItemOriginTypeOverpay: string = '00000207-1000-0000-0000-000000000004';
  enumARLedgerItemOriginTypeTransaction: string = '00000207-1000-0000-0000-000000000003';
  //enumStatusPaid: string = '00000083-1000-0000-0000-000000000002';
  //enumStatusOutstanding: string = '00000083-1000-0000-0000-000000000001';
  enumLedgerItemTypeCreditAdjustment: string = '00000078-1000-0000-0000-000000000007';
  enumLedgerItemTypeCreditAdjustmentInsurance: string = '00000078-1000-0000-0000-000000000008';
  enumLedgerItemTypeCreditCreatedFromPaymentVoid: string = '00000078-1000-0000-0000-000000000014';
  enumTypeCredit: string = '00000078-1000-0000-0000-000000000001';
  enumTypeRefund: string = '00000078-1000-0000-0000-000000000005';
  enumTypeDebitAdjustment: string = '00000078-1000-0000-0000-000000000006';
  enumDebitAdjustmentActionDebitPatientAccount = '00000534-1000-0000-0000-000000000001';
  enumDebitAdjustmentActionIssueCheckInQuickBooks = '00000534-1000-0000-0000-000000000002';
  enumDebitAdjustmentActionIssueCreditCardRefund = '00000534-1000-0000-0000-000000000003';
  enumARReasonCreditAdjustmentID: string;
  enumARReasonDebitAdjustmentID: string;
  enumARReasonAdjustmentID: string;
  enumARReasonAdjustment: string;
  paymentIDToVoid: string;
  paymentToVoid: DataARLedgerListModel;
  payment: DataARPaymentModel;
  adjustmentNote: string = '';

  arAccounts: CfgARAccountModel[] = [];
  locations: LOCIDModel[] = [];
  enumDebitAdjustmentActions: EnumValidValueItemModel[] = [];
  creditDebitReasons: DataARCreditDebitReasonModel[] = [];
  paymentRecordsCC: CreditCardRefundablePaymentModel[] = [];

  selectedARAccount: CfgARAccountModel;
  selectedLocation: LOCIDModel;
  selectedDate: Date = new Date();
  selectedLedgerItem: DataARLedgerListModel;
  selectedEnumDebitAdjustmentAction: EnumValidValueItemModel;
  selectedCreditDebitReason: DataARCreditDebitReasonModel;

  TZID: string = '';
  tzOffsetMins: number = 0;

  enumCreditDebitTypeCredit: string = '00000538-1000-0000-0000-000000000001';
  enumCreditDebitTypeDebit: string = '00000538-1000-0000-0000-000000000002';

  private overlayRef: OverlayRef | null;
  private sub: Subscription;
  footerMessage: string = '';
  paymentToRefund: CreditCardRefundablePaymentModel;
  isDoctorARQuickBooksIntegration: boolean = false;

  CCRefundTableColumns: string[] = ['PaymentTransactionDate', 'Description', 'ARAccountName', 'PaymentAmount', 'AmountAvailable', 'Refund', 'PaymentID'];

  requiredNotes: boolean = false;
  requiredLedgerItem: boolean;
  requiredLocation: boolean;
  requiredARAccount: boolean;
  requiredAmount: boolean;
  CCRefundAmountToRefund: number = 0;

  constructor(
    public dialogRef: MatDialogRef<CreateAdjustment2Component>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private arService: ARService,
    //private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private globals: Globals,
    private cp: CurrencyPipe,
    private messagingService: MessagingService,
    private notesService: NotesService,
    private overlay: Overlay,
    private viewContainerRef: ViewContainerRef,
    private toastr: ToastrService,
    private currencyPipe: CurrencyPipe,
    private readonly staticDataService: StaticDataService
  ) { }

  ngOnInit(): void {
    this.isLoading = true;
    this.LOCID = parseInt(localStorage.getItem('LOCID'));
    this.type = this.data.type;
    this.ledgerItems = this.data.dataLedgerItems;
    this.ledgerItemsList = this.data.dataLedgerItems;

    if (this.data.paymentLedgerItemToVoid) {
      this.paymentToVoid = this.data.paymentLedgerItemToVoid;
    }

    this.ledgerItem = new DataARLedgerListModel();
    this.ledgerItem.PatientId = this.data.PatientId;
    this.ledgerItem.Amount = 0;
    this.ledgerItem.enumARLedgerItemOriginTypeID = this.enumARLedgerItemOriginTypePatient;
    this.ledgerItem.enumLedgerItemStatusID = LEDGER_ITEM_STATUS.Outstanding;

    if (this.type === 'credit') {
      this.ledgerItem.enumARLedgerItemTypeID = this.enumTypeCredit;
      this.ledgerItem.enumARLedgerItemOriginTypeID = this.enumARLedgerItemOriginTypeOverpay;
    }
    else {
      // debit
      this.ledgerItem.enumARLedgerItemTypeID = this.enumTypeDebitAdjustment;
      if (this.selectedLedgerItem) {
        if (this.selectedLedgerItem.enumARLedgerItemOriginTypeID === this.enumARLedgerItemOriginTypePatient) {
          this.ledgerItem.enumARLedgerItemOriginTypeID = this.selectedLedgerItem.enumARLedgerItemOriginTypeID;
        }
      }
    }

    // credits
    this.ledgerItemsCredits = this.ledgerItems.filter(a => a.enumLedgerItemStatusID === LEDGER_ITEM_STATUS.Outstanding && a.enumARLedgerItemTypeID === this.enumLedgerItemTypeCreditAdjustment);
    this.ledgerItemsCredits.forEach(a => {
      a.RefundAmount = a.Amount;
      a.RefundChecked = true;
    });

    // title
    if (this.type === 'debit') {
      this.title = 'Debit Adjustment';
    }
    else if (this.type === 'credit') {
      this.title = 'Credit Adjustment';
    }
    else if (this.type === 'void-payment') {
      this.title = 'Void Payment Transaction';
    }

    this.setRequiredFields();
    this.init();
  }

  setRequiredFields(){

    if (this.type === 'credit') {
      this.requiredLocation  = true;
      this.requiredARAccount = true;
    }
    else if (this.type === 'debit' && this.selectedEnumDebitAdjustmentAction &&
      this.selectedEnumDebitAdjustmentAction.ValidValueItemId === this.enumDebitAdjustmentActionIssueCreditCardRefund) {
      this.requiredLocation = true;
    }
    else if (this.type === 'debit' && this.selectedEnumDebitAdjustmentAction && this.selectedEnumDebitAdjustmentAction.ValidValueItemId === this.enumDebitAdjustmentActionIssueCheckInQuickBooks) {
      this.requiredLocation = true;
    }
    else if (this.type === 'debit' && this.selectedEnumDebitAdjustmentAction && this.selectedEnumDebitAdjustmentAction.ValidValueItemId === this.enumDebitAdjustmentActionDebitPatientAccount) {
      this.requiredLocation  = true;
      this.requiredARAccount  = true;
      this.requiredLedgerItem = true;
    }
    else if (this.type === 'void-payment') {
      this.requiredNotes = true;
    }
  }
  async init() {
    const promises: any[] = [
      this.getLocations(),
      this.getAllDoctorARLocations(),
      this.getEnumValidValueItemsByValidValueName('enumDebitAdjustmentAction'),
      this.arService.getDebitCreditReasons(this.LOCID).toPromise(),
      this.arService.getCCPaymentRecordsForPatient(this.data.PatientId).toPromise()
    ];

    if (this.paymentToVoid) {
      promises.push(this.arService.getPaymentRecordByID(this.paymentToVoid.PaymetnID).toPromise());
      promises.push(this.arService.getAllARAccounts().toPromise());
    }

    try {
      const results: any[] = await Promise.all(promises);
      this.locations = results[0];
      this.arAccounts = results[1];
      this.enumDebitAdjustmentActions = results[2];
      this.creditDebitReasons = results[3];
      this.paymentRecordsCC = results[4];

      this.selectedEnumDebitAdjustmentAction = this.enumDebitAdjustmentActions[0];


      if (this.paymentToVoid) {
        // voiding a payment
        this.payment = results[5];
        this.arAccounts = results[6];
        this.ledgerItem = this.paymentToVoid;
        this.selectedLocation = this.locations.find(a => Number(a.LOCID) === this.ledgerItem.LOCID);
        this.selectedARAccount = this.arAccounts.find(a => a.ARAccountID === this.payment.DepositARAccountID);
        this.ledgerItemText = this.ledgerItem.Description;
        // trigger change event for amount
        this.raiseCustomEvent2('debitAmount', this.ledgerItem.Amount);
      }

      // filter creditDebitReasons by type
      this.filterCreditDebitReasonsByType();

      this.isLoading = false;
    }
    catch (err) {
      console.log(err);
      this.displayMessage('Something went wrong', 'Error');
      this.isLoading = false;
    }
  }

  filterCreditDebitReasonsByType() {
    if (this.type === 'debit') {
      this.creditDebitReasons = this.creditDebitReasons.filter(a => a.enumCreditDebitTypeID === this.enumCreditDebitTypeDebit);
    }
    else if (this.type === 'credit') {
      this.creditDebitReasons = this.creditDebitReasons.filter(a => a.enumCreditDebitTypeID === this.enumCreditDebitTypeCredit);
    }
    else if (this.type === 'void-payment') {
      this.creditDebitReasons = this.creditDebitReasons.filter(a => a.enumCreditDebitTypeID === this.enumCreditDebitTypeCredit);
    }
  }

  async onLocationChange() {
    this.selectedARAccount = null;
    const promises: any[] = [
      this.getAllDoctorARLocationsByLOCID(parseInt(this.selectedLocation.LOCID)),
    ];

    try {
      const results: any[] = await Promise.all(promises);
      this.arAccounts = results[0];
      this.refreshSystemsIntegration();

    }
    catch (err) {
      console.log(err);
      this.displayMessage('Something went wrong', 'Error');
    }
  }

  async save() {
    this.footerMessage = '';
    if (!this.validateAmount()) {
      return;
    }
    try {
      this.isLoading = true;

      this.ledgerItem.DoctorARLocId = this.selectedLedgerItem ? this.selectedLedgerItem.DoctorARLocId : null;
      this.ledgerItem.ParentLedgerID = this.selectedLedgerItem ? this.selectedLedgerItem.LedgerID : null;

      this.ledgerItem.Description = this.selectedCreditDebitReason.Reason;
      if (this.ledgerItemText) {
        this.ledgerItem.Description += ' | ' + this.ledgerItemText;
      }

      this.ledgerItem.PostDate = this.selectedDate;
      console.log("Save Date:", this.ledgerItem.PostDate);
      this.ledgerItem.LOCID = parseInt(this.selectedLocation.LOCID);
      this.ledgerItem.enumARLedgerItemOriginTypeID = this.selectedLedgerItem ? this.selectedLedgerItem.enumARLedgerItemOriginTypeID : null;
      if (this.selectedARAccount && this.type !== 'void-payment') {
        this.ledgerItem.Reference = this.selectedARAccount.AccountName;
      }

      const currDate = new Date();
      console.log("Save Date system:", currDate);
      const newDate = new Date(this.selectedDate.getFullYear(), this.selectedDate.getMonth(), this.selectedDate.getDate(), currDate.getHours(), currDate.getMinutes(), 0);
      this.ledgerItem.PostDate = newDate;
      console.log("Save Date calculated:", this.ledgerItem.PostDate);
      if (this.selectedEnumDebitAdjustmentAction.ValidValueItemId === this.enumDebitAdjustmentActionIssueCreditCardRefund) {
        this.ledgerItem.PaymetnID = this.paymentToRefund ? this.paymentToRefund.PaymentID : null;
        this.ledgerItem.enumCurrencyID = this.paymentToRefund ? this.paymentToRefund.enumCurrencyID : null;
        this.ledgerItem.enumLedgerItemStatusID = LEDGER_ITEM_STATUS.Outstanding;
        this.ledgerItem.enumARLedgerItemTypeID = this.enumTypeRefund;
        this.ledgerItem.enumARLedgerItemOriginTypeID = this.enumARLedgerItemOriginTypeTransaction;
      }
      if (this.type === 'void-payment') {
        // handle payment voiding tasks
        await this.arService.voidPayment(this.paymentToVoid.PaymetnID, this.selectedCreditDebitReason.enumARReasonCreditAdjustmentID)
        .subscribe((response) => {
          console.log(response);
        });

        // send ledger item to call that records the reason.. or pass reason along to call above
        // save reason in the voided ledger item's description

        // record reason in note
        if (this.adjustmentNote !== '') {
          this.createNoteForLedgerItem();
        }

        // update ledger line item for voided payment
        // this.ledgerItem.Description = this.ledgerItemText;
        // this.ledgerItem.Reference = 'Voided Distribution(s) - ' + this.ledgerItem.Reference;
        // // this.ledgerItem.enumARLedgerItemTypeID = this.enumTypeCredit;
        // this.ledgerItem.enumARLedgerItemOriginTypeID = this.paymentToVoid.enumARLedgerItemOriginTypeID;
        // const ledgerReturn: DataARLedgerModel = await this.arService.saveLedgerItem(this.ledgerItem).toPromise();

        this.isLoading = false;
        this.displayMessage('Payment Voided', 'Success');
        this.close(true);
      }
      else {

        //refund text:
        if (this.selectedEnumDebitAdjustmentAction.ValidValueItemId === this.enumDebitAdjustmentActionIssueCreditCardRefund)
          this.ledgerItem.Description = 'CC Refund: ' + this.ledgerItem.Description;

        //create ledger item
        const ledgerReturn: DataARLedgerModel = await this.arService.saveLedgerItem(this.ledgerItem).toPromise();
        this.ledgerItem.LedgerID = ledgerReturn.LedgerID;
        if (this.adjustmentNote !== '') {
          // this.saveNote();
          this.createNoteForLedgerItem();
        }

        // if credit, also create patient credit item to be applied elsewhere
        if (this.type === 'credit') {
          const patientCreditLedgerItem = new DataARLedgerListModel();
          patientCreditLedgerItem.PatientId = this.data.PatientId;
          patientCreditLedgerItem.Amount = this.ledgerItem.Amount;
          patientCreditLedgerItem.enumARLedgerItemOriginTypeID = this.enumARLedgerItemOriginTypePatient;
          patientCreditLedgerItem.enumLedgerItemStatusID = LEDGER_ITEM_STATUS.Outstanding;
          patientCreditLedgerItem.enumARLedgerItemTypeID = this.enumLedgerItemTypeCreditAdjustment;
          patientCreditLedgerItem.LOCID = parseInt(this.selectedLocation.LOCID);
          const currDate = new Date();
          const newDate = new Date(this.selectedDate.getFullYear(), this.selectedDate.getMonth(), this.selectedDate.getDate(), currDate.getHours(), currDate.getMinutes(), 0);

          patientCreditLedgerItem.PostDate = newDate;
          console.log("Credit patientCreditLedgerItem Save Date:", patientCreditLedgerItem.PostDate);
          if (this.selectedLedgerItem && this.selectedLedgerItem.Description) {
            patientCreditLedgerItem.Description = this.selectedLedgerItem.Description;
          }
          patientCreditLedgerItem.Reference = 'Credit from credit adjustment';

          // send to server
          const patientCreditLedgerItemReturn: DataARLedgerModel = await this.arService.saveLedgerItem(patientCreditLedgerItem).toPromise();
        }

        // if debit adjustment, and if insurance overpay credit chosen as ledger item reference..
        const creditObj = new DataArLedgerCredits();
        creditObj.PatientID = this.data.PatientId;
        creditObj.enumARLedgerItemOriginType = this.enumARLedgerItemOriginTypeInsurance;
        creditObj.enumARLedgerItemType = this.enumLedgerItemTypeCreditAdjustmentInsurance;
        creditObj.Amount = this.ledgerItem.Amount;

        // if debit and quickbooks was selected
        if (this.type === 'debit' && this.selectedEnumDebitAdjustmentAction.ValidValueItemId === this.enumDebitAdjustmentActionIssueCheckInQuickBooks) {
          this.ledgerItemsCredits.forEach(a => {
            if (a.RefundChecked && a.RefundAmount > 0) {
              creditObj.ledgerItems.push(a);
            }
          });
          await this.arService.resolveLedgerCreditItems2(creditObj).toPromise();
        }


        this.displayMessage('Adjustment created', 'Success');

        if (this.type === 'debit') {
          if (this.selectedEnumDebitAdjustmentAction.ValidValueItemId === this.enumDebitAdjustmentActionIssueCreditCardRefund) {
            const refundRequest: CreditCardRefundRequest = {
              PaymentID: this.paymentToRefund.PaymentID,
              Amount: this.ledgerItem.Amount,
              LedgerItemID: ledgerReturn.LedgerID,
            };
            this.arService.requestCreditCardRefund(refundRequest).subscribe((response) => {
              if (response.Success) {
                this.displayMessage('Credit Card Refund Successful', 'Success');

                // need to update affected payment transactions
                const paymentsRefunded = this.paymentRecordsCC.filter(a => a.IsDistribution && a.Refund >0);
                paymentsRefunded.forEach(a => {
                  a.ReasonID = this.selectedCreditDebitReason.enumARReasonDebitAdjustmentID;
                });
                this.updateRefundedPaymentDistributions(this.paymentToRefund.PaymentID, paymentsRefunded);

                this.isLoading = false;
                this.close(this.ledgerItem);
              }
              else {
                this.displayMessage('Credit Card Refund Failed', 'Error');
                this.footerMessage = `Credit Card Refund Failed: ${response.Message}`;
                this.isLoading = false;
              }
            }, (error) => {
              console.log(error);
              this.displayMessage(`Credit Card Refund Error: ${error.Message ?? error.error.ExceptionMessage}`, 'Error');
              this.footerMessage = `Credit Card Refund Error: ${error.Message ?? error.error.ExceptionMessage}`;

              this.isLoading = false;

            }
              , () => {
                this.isLoading = false;
              }
            );

          }
          else if (this.selectedEnumDebitAdjustmentAction.ValidValueItemId === this.enumDebitAdjustmentActionIssueCheckInQuickBooks) {
            this.displayMessage('Quickbooks not yet implemented', 'Success');
            this.isLoading = false;
            this.close(true);
          }
          else {
            this.isLoading = false;
            this.close(this.ledgerItem);
          }
        }
        else{
          this.isLoading = false;
          this.close(true);
        }
      }

    } catch (err) {
      console.log(err);
      this.isLoading = false;
      this.displayMessage('Something went wrong', 'Error');
      this.close(false);
    }

  }

  async updateRefundedPaymentDistributions(PaymentID: string, ccRefundRecords: CreditCardRefundablePaymentModel[]) {
    const promises: any[] = [
      this.arService.updateCreditCardRefundPaymentDistributions(PaymentID, ccRefundRecords).toPromise(),
    ];

    try {
      const results: any[] = await Promise.all(promises);
      const result = results[0];
      const blah = '';
    }
    catch (err) {
      console.log(err);
      this.displayMessage('Something went wrong', 'Error');
    }
  }

  close(payload) {
    this.dialogRef.close(payload);
  }

  displayMessage(message, type) {
    if (type.toLowerCase() === "error")
      this.toastr.error(message, null, { timeOut: 7000 });
    else if (type.toLowerCase() === "warning")
      this.toastr.warning(message, null, { timeOut: 3000 });
    else
      this.toastr.success(message, null, { timeOut: 3000 });
  }


  getLocations() {
    return this.arService.getLocations().toPromise();
  }

  getAllDoctorARLocations() {
    const promise = new Promise((resolve, reject) => {
      this.arService.getAllDoctorARLocations()
        .subscribe(resolve, reject);
    });
    return promise;
  }

  getAllDoctorARLocationsByLOCID(LOCID: number) {
    const promise = new Promise((resolve, reject) => {
      this.arService.getAllDoctorARLocationsByLOCID(LOCID)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  getDoctorARLocationIntegration(LOCID: number, DoctorId: string) {
    const promise = new Promise((resolve, reject) => {
      this.arService.getDoctorARLocationIntegration(LOCID, DoctorId)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  getEnumValidValueItemsByValidValueName(ValidValueName: string) {
    return this.staticDataService.getEnumValidValueItemsByValidValueName(ValidValueName).toPromise();
  }

  onPaymentRefundSelected(event: MatRadioChange, payment: CreditCardRefundablePaymentModel) {
    this.paymentToRefund = payment;
  }

  async openChooseLedgerItemWindow() {
    const dialogRef = this.dialog.open(ArLedgerItemSelectComponent, {
      panelClass: 'dialog',
      autoFocus: false,
      data: {
        dataLedgerItems: this.ledgerItemsList.filter(
                    a => a.enumLedgerItemStatusID !== LEDGER_ITEM_STATUS.Void),
        type: this.type
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.selectedLedgerItem = result;
        this.ledgerItemText = this.selectedLedgerItem.Description;

        // set defaults
        this.selectedLocation = this.locations.find(a => Number(a.LOCID) === this.selectedLedgerItem.LOCID);

        // reload ar accounts list and set selected
        this.LoadDefaultARAccountForLedgerItem();
      }
    }, err => {
    });
  }

  async LoadDefaultARAccountForLedgerItem() {
    await this.onLocationChange();
    this.selectedARAccount = this.arAccounts.find(a => a.DoctorARLocId === this.selectedLedgerItem.DoctorARLocId);
  }

  defaultToCurrentLocation() {
    this.locations.forEach(a => {
      if (a.LOCID === this.globals.LOCID) {
        this.selectedLocation = a;
      }
    });
  }

  debitActionChanged() {
    if (this.ledgerItem) {
      this.ledgerItem.Amount = 0;
    }
    if (this.selectedEnumDebitAdjustmentAction && this.selectedEnumDebitAdjustmentAction.ValidValueItemId === this.enumDebitAdjustmentActionIssueCheckInQuickBooks) {
      this.defaultToCurrentLocation();
      this.updateTotalRefundAmount();
    }

  }

  readyToSave() {
    // requirements for both debit and credit

    if (this.type === 'credit') {
      if (this.selectedCreditDebitReason && this.selectedDate && this.ledgerItem.Amount && this.selectedCreditDebitReason.enumARReasonCreditAdjustmentID && this.selectedLocation && this.selectedARAccount) {
        return true;
      }
    }
    else if (this.type === 'debit' && this.selectedEnumDebitAdjustmentAction &&
      this.selectedEnumDebitAdjustmentAction.ValidValueItemId === this.enumDebitAdjustmentActionIssueCreditCardRefund) {
      // debit to patient account

      if (this.selectedCreditDebitReason && this.selectedDate && this.ledgerItem.Amount
            && this.selectedCreditDebitReason.enumARReasonDebitAdjustmentID && this.selectedLocation) {
              if ( this.paymentToRefund?.AvailableAmount < this.CCRefundAmountToRefund){
                this.footerMessage = `Refund amount exceeds available balance in payment`;
                return false;
              }
              this.footerMessage = '';
        this.paymentRecordsCC.some(a => {
          if (a.IsDistribution && this.CCRefundIsParentChecked(a.PaymentID)) {
            if (this.getNumber(a.Refund) > this.getNumber(a.PaymentAmount)) {
              this.footerMessage = `Refund amount cannot be greater than payment amount`;
              return false;
            }
          }
        });
        return true;
      }
    }
    else if (this.type === 'debit' && this.selectedEnumDebitAdjustmentAction && this.selectedEnumDebitAdjustmentAction.ValidValueItemId === this.enumDebitAdjustmentActionIssueCheckInQuickBooks) {
      // quickbooks
      if (this.selectedCreditDebitReason && this.selectedDate && this.selectedCreditDebitReason.enumARReasonDebitAdjustmentID && this.selectedLocation) {
        return true;
      }
    }
    else if (this.type === 'debit' && this.selectedEnumDebitAdjustmentAction && this.selectedEnumDebitAdjustmentAction.ValidValueItemId === this.enumDebitAdjustmentActionDebitPatientAccount) {
      // debit patient account
      if (this.selectedCreditDebitReason && this.selectedDate && this.selectedCreditDebitReason.enumARReasonDebitAdjustmentID
        && this.selectedLocation && this.selectedARAccount && this.selectedLedgerItem) {
        return true;
      }
    }
    else if (this.type === 'void-payment' && this.selectedDate && this.adjustmentNote && this.selectedCreditDebitReason) {
      return true;
    }
    else {
      return false;
    }
  }

  onCreditRowSelected($event: TdoTableSelectionEvent) {

  }

  convertUTCDatetoTimezone(date: Date, tz: string) {
    date = ConversionUtilities.getAdjustedTimezoneDate(date, tz);
    return date;
  }

  refundRowChecked(ledgerID: string, amount: number) {
    this.ledgerItemsCredits.forEach(a => {
      if (a.LedgerID === ledgerID && !a.RefundChecked) {
        a.RefundAmount = 0;
        amount = 0;
      }
    });

    this.updateTotalRefundAmount();

    // trigger change event
    this.raiseCustomEvent2('refundRow' + ledgerID, amount);
  }

  updateTotalRefundAmount() {
    let amount: number = 0;
    this.ledgerItemsCredits.forEach(a => {
      if (a.RefundChecked) {
        amount = amount + parseFloat(a.RefundAmount.toString());
      }
    });
    this.ledgerItem.Amount = amount;
    // trigger change event
    this.raiseCustomEvent2('debitAmount', this.ledgerItem.Amount);
  }

  raiseCustomEvent2(id: string, amount: number) {
    const evt = new CustomEvent('valChange', { detail: { amt: amount.toString() } });
    setTimeout(() => document.getElementById(id).dispatchEvent(evt), 200);
  }

  onUpdateRefundAmount(event, row: DataARLedgerListModel) {
    // set value
    let val: number = 0;
    if (event.target.value) {
      val = parseFloat(event.target.value);
      if (val <= row.Amount) {
        row.RefundAmount = val;
      }
      else {
        row.RefundAmount = 0;
      }
    }

    // model updated...
    this.updateTotalRefundAmount();
  }

  saveNote() {

    const mod = new TdoNoteSaveModel();
    mod.text = this.adjustmentNote;
    mod.patientId = this.globals.currentPatientId;

    const assoc = new TdoNoteAssociatedObject();
    assoc.objectId = this.ledgerItem.LedgerID;
    assoc.parentObjectName = 'dataARLedger';
    mod.associatedObjects = [];
    mod.associatedObjects.push(assoc);

    mod.categoryEnumIds = [NoteCategoryEnum.Ledger];
    mod.typeEnumIds = [NoteTypeEnum.Administartive];
    this.notesService.saveNote(mod).subscribe((res) => {
      this.messagingService.sendComponentMessage(MessagingConstants.NOTES_REFRESH, {});
    });
  }

  createNoteForLedgerItem() {
    // add note for ledger item
    const model = new TdoNoteSaveModel();
    model.patientId = this.data.PatientId;
    model.text = this.adjustmentNote;

    const associatedObjects = [];
    const newAssociatedObject = new TdoNoteAssociatedObject();
    newAssociatedObject.objectId = this.ledgerItem.LedgerID;
    newAssociatedObject.parentObjectName = 'dataARLedger';
    associatedObjects.push(newAssociatedObject);

    model.associatedObjects = associatedObjects;
    model.categoryEnumIds.push(NoteCategoryEnum.Ledger);
    model.typeEnumIds.push(NoteTypeEnum.Administartive);
    model.typeEnumIds.push(NoteTypeEnum.Patient);
    this.messagingService.sendComponentMessage(MessagingConstants.NOTES_CREATE_NOTE, model);
  }

  openEditReasons(event: MouseEvent) {
    this.openContext(event, this.editReasonContextTemplate, null);
  }

  openContext({ x, y }: MouseEvent, template: TemplateRef<any>, data: any, closeOnItemClick = true): void {
    this.closeContext();
    x = x + 100;
    y = y - 20;
    const positionStrategy = this.overlay.position().flexibleConnectedTo({ x, y }).withPositions([
      {
        originX: 'end',
        originY: 'bottom',
        overlayX: 'end',
        overlayY: 'top'
      }
    ]);

    this.overlayRef = this.overlay.create({
      positionStrategy,
      scrollStrategy: this.overlay.scrollStrategies.close()
    });

    this.overlayRef.attach(new TemplatePortal(template, this.viewContainerRef, { $implicit: data }));

    this.sub = fromEvent<MouseEvent>(document, 'click')
      .pipe(
        filter(event => {
          if (closeOnItemClick) {
            this.closeContext();
          } else {
            const clickTarget = event.target as HTMLElement;
            return !!this.overlayRef && !this.overlayRef.overlayElement.contains(clickTarget);
          }
        }), take(1)).subscribe(() => this.closeContext());
  }

  closeContext(): void {
    this.sub !== undefined && this.sub.unsubscribe();
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = null;
    }
  }

  async openDebitCreditReasons() {
    const dialogRef = this.dialog.open(ArDebitCreditReasonsComponent, {
      width: '700px',
      height: '700px',
      panelClass: 'dialog',
      data: {
        reasonType: this.type
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // changes were saved
        // update reasons list
        this.loadReasons(true);
      }
    }, err => {
    });
  }

  async loadReasons(ignoreCache:boolean=false) {
    this.selectedARAccount = null;
    const promises: any[] = [
      this.arService.getDebitCreditReasons(this.LOCID, ignoreCache).toPromise(),
    ];

    try {
      const results: any[] = await Promise.all(promises);
      this.creditDebitReasons = results[0];
      this.filterCreditDebitReasonsByType();
    }
    catch (err) {
      console.log(err);
      this.displayMessage('Something went wrong', 'Error');
    }
  }

  validateAmount(): boolean {

    this.footerMessage = '';
    if (this.ledgerItem.Amount <= 0) {
      this.footerMessage = 'Amount must be greater than 0';
      return false;
    }
    if (this.selectedEnumDebitAdjustmentAction.ValidValueItemId !== this.enumDebitAdjustmentActionDebitPatientAccount && this.selectedEnumDebitAdjustmentAction.ValidValueItemId !== this.enumDebitAdjustmentActionIssueCheckInQuickBooks) {
      if (this.ledgerItem.Amount > this.paymentToRefund.AvailableAmount) {
        this.footerMessage = 'Refund must be less than or equal to the available amount';
        return false;
      }
    }
    return true;
  }

  onCCRefundRowContextMenu($event: MouseEvent, row) {

  }

  onCCRefundRowSelectedClick(row) {

  }

  onUpdateCCRefundAmount(event, element) {
    // set value
    // this.paymentRecordsCC.forEach(a => {
    //   if (a.PaymetnDistributionID === element.PaymetnDistributionID) {
    //     a.Refund = event.target.value;
    //   }
    // });
    let paymentRecord = this.paymentRecordsCC.find(a => a.PaymetnDistributionID === element.PaymetnDistributionID);
    if (paymentRecord) {
      console.log("Refund value: ", event.target.value);
      paymentRecord.Refund = this.getNumber(event.target.value);
      console.log("Refund value parsed: ", paymentRecord.Refund);
    }

    // model updated...
    this.refreshCCRefundData();
    this.refreshCCRefundAmountToRefund();
  }

  CCRefundIsParentChecked(PaymentID: string) {
    let blReturn = false;
    this.paymentRecordsCC.forEach(a => {
      if (a.PaymentID === PaymentID && a.isChecked && a.IsPayment) {
        blReturn = true;
      }
    });
    return blReturn;
  }

  refundCCChecked(paymentId: string) {
    this.paymentRecordsCC.forEach(a => {
      if (a.PaymentID !== paymentId && a.isChecked && a.IsPayment) {
        a.isChecked = false;
      }
      else if (a.PaymentID === paymentId && a.isChecked && a.IsPayment) {
        this.paymentToRefund = a;
      }
      a.Refund = 0;
    });

    this.refreshCCRefundData();
    this.refreshCCRefundAmountToRefund();
    this.refreshSystemsIntegration();
  }

  async refreshSystemsIntegration() {
    if (this.paymentToRefund?.DoctorID && this.selectedLocation?.LOCID) {
      const promises: any[] = [
        this.getDoctorARLocationIntegration(parseInt(this.selectedLocation.LOCID), this.paymentToRefund?.DoctorID)
      ];
      try {
        const results: any[] = await Promise.all(promises);
        this.isDoctorARQuickBooksIntegration = results[0] == ArIntegration_QuickBooks;
      }
      catch (err) {
        console.log(err);
        this.displayMessage('Something went wrong', 'Error');
      }
    }
  }

  refreshCCRefundData() {
    this.ccRefundTable.dataSource = this.paymentRecordsCC;
  }

  refreshCCRefundAmountToRefund() {
    let refundAmount = 0;
    if (this.selectedEnumDebitAdjustmentAction.ValidValueItemId === this.enumDebitAdjustmentActionIssueCreditCardRefund) {
      this.paymentRecordsCC.forEach(a => {
        if (a.IsDistribution && this.CCRefundIsParentChecked(a.PaymentID)) {
          refundAmount = parseFloat(refundAmount.toString()) + parseFloat(a.Refund.toString().replace('$', ''));
        }
      });
    }
    this.ledgerItem.Amount = refundAmount;
    this.CCRefundAmountToRefund = refundAmount;
    this.raiseCustomEvent2('debitAmount', refundAmount);

    if ( this.paymentToRefund?.AvailableAmount < this.CCRefundAmountToRefund){
      this.footerMessage = `Refund amount exceeds available balance in payment`;
    }
    return refundAmount;
  }

  getNumber(value) {
    return parseFloat(value.toString().replace('$', ''));
  }
}
